import { render } from "./auxiliary.vue?vue&type=template&id=ea3251ca&scoped=true"
import script from "./auxiliary.vue?vue&type=script&lang=js"
export * from "./auxiliary.vue?vue&type=script&lang=js"

import "./auxiliary.vue?vue&type=style&index=0&id=ea3251ca&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea3251ca"]])

export default __exports__